import { PageHeader } from "@/components/common";
import { BookingTool } from "@/components/booking/BookingTool";

export default function Booking() {
  return (
    <div>
      <PageHeader title="Book a Station" subtitle="Reserve your rig and lock in your session." />
      <BookingTool mode="member" />
    </div>
  );
}
